import React from "react";

function Icons() {
  // Liste des icônes dans public/icons
  const iconList = [
    { file: "Treatment.svg", name: "Administration of a product/treatment" },
    { file: "Surgery.svg", name: "Surgery" },
    { file: "BehaviorTest.svg", name: "Behavioral test" },
    { file: "PhysiologicalTest.svg", name: "Physiological test" },
    { file: "ElectrophysiologicalTest.svg", name: "Electrophysiological test" },
    { file: "Irradiation.svg", name: "Irradiation" },
    { file: "TumorInduction.svg", name: "Tumor induction" },
    { file: "CollectionOfSamples.svg", name: "Collection of samples" },
    { file: "Imaging.svg", name: "Imaging" },
    { file: "Marking.svg", name: "Marking" },
    { file: "TerminalIntervention.svg", name: "Terminal intervention" },
  ];

  return (      
    <div style={{ textAlign: "center", padding: "20px", paddingTop: "100px" }}>
      <h3>Icon Library</h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "40px",
          justifyItems: "center",
        }}
      >
        {iconList.map((icon, index) => (
          <div key={index} style={{ textAlign: "center" }}>
            <img
              src={`/icons/${icon.file}`}
              alt={icon.name}
              style={{ width: "100px", height: "100px", marginBottom: "10px" }}
            />
            <div>{icon.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
  
}

export default Icons;
